document.addEventListener('DOMContentLoaded',()=>{

    function fetchUrl(url){
        fetch(url)
        .then(response => response.text())
        .then(html =>{
        const productGrid = document.querySelector('#ProductGridContainer');
        const productCount = document.querySelector('#product_count');
        
        const filterForm = document.querySelector('#CollectionFiltersForm .filter-box-inner'); 
        const parser = new DOMParser();
        const doc = parser.parseFromString(html , 'text/html');
        const newProductGrid = doc.querySelector('#ProductGridContainer');
        const newFilterForm = doc.querySelector('#CollectionFiltersForm .filter-box-inner');
        const newProductCount = doc.querySelector('#product_count');
        console.log("newProductCount",newProductCount)
        if(newProductGrid){
            productGrid.innerHTML = newProductGrid.innerHTML;
        }
        if(newFilterForm){
            filterForm.innerHTML = newFilterForm.innerHTML;
        }
        if(newProductCount){
            productCount.innerHTML = newProductCount.innerHTML;
        }
       
        sorting();
        filter();
        clearLabel();
        ClearAll();
        observeLoadMore();
        })
    }
    
    function sorting(){
        const sortBySelect = document.querySelector('#sort-by');
        if(sortBySelect){
            sortBySelect.addEventListener('change',function(){
                const selectedSortValue = this.value;
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('sort_by',selectedSortValue);
                fetchUrl(currentUrl)
                history.pushState({},'',currentUrl.toString())
            })
        }
    }
    function filter(){
        const filterForm = document.querySelector('#CollectionFiltersForm');
        if(filterForm){
            const inputs = document.querySelectorAll('input[type="checkbox"], input[type="radio"]');
            inputs.forEach(input => {
                input.addEventListener('change',function(){
                const formData = new FormData(filterForm);
                const searchParams = new URLSearchParams(formData).toString();
                const currentUrl = new URL(window.location.href);
                currentUrl.search = searchParams;
                fetchUrl(currentUrl)
                history.pushState({},'',currentUrl.toString())
                })
            })

            // price filter
            let timer;
            const priceInputs = document.querySelectorAll('.filter-price-input');

            priceInputs.forEach(input => {
                input.addEventListener('input', function() {
                    clearTimeout(timer);

                    timer = setTimeout(() => {
                    const formData = new FormData(filterForm);
                    const searchParams = new URLSearchParams(formData).toString();

                    const currentUrl = new URL(window.location.href);
                    currentUrl.search = searchParams;

                    fetchUrl(currentUrl);
                    history.pushState({}, '', currentUrl.toString());
                    }, 500);
                });
            });
        }
    }
    function ClearAll(){
    const clearAll = document.querySelector('#clear-all');
    if(clearAll){
        clearAll.addEventListener('click',function(e){
            e.preventDefault();
            const currentUrl = this.getAttribute('href');
            fetchUrl(currentUrl)
            history.pushState({},'',currentUrl.toString())
        })
        }
    }
    function clearLabel(){
        const activeFiltersContainer = document.querySelector('#ActiveFiltersContainer');
        if(activeFiltersContainer){
        activeFiltersContainer.addEventListener('click', function(event) {
            const labelClicked = event.target.closest('.clear-filter-label');
            if (labelClicked) {
            event.preventDefault(); 
            const removeUrl = labelClicked.getAttribute('href');
            fetchUrl(removeUrl)
            history.pushState({},'',removeUrl.toString())
            }
        });
        } 
    }
    
    let isFetching = false;
    let observer;

    function loadMore() {
    const btn = document.querySelector(".load-more");
    if (!btn || isFetching) return;

    const url = btn.getAttribute("href");
    if (!url) return;

    isFetching = true;

    fetch(url)
        .then((res) => res.text())
        .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        let newItems = doc.querySelectorAll(".productgrid--items > *");
        let container = document.querySelector(".productgrid--items");

        if (!newItems.length) {
            newItems = doc.querySelectorAll(".product-item > *");
            container = document.querySelector(".product-item");
        }

        if (!container) return;

        newItems.forEach((item) => {
            container.appendChild(item);
        });

        const newBtnWrapper = doc.querySelector(".lodeMore-btn-wpr");
        const oldBtnWrapper = document.querySelector(".lodeMore-btn-wpr");

        if (newBtnWrapper && oldBtnWrapper) {
            oldBtnWrapper.replaceWith(newBtnWrapper);
            observeLoadMore(); // Observe the new button
        } else if (oldBtnWrapper) {
            oldBtnWrapper.remove();
        }
        })
        .catch((err) => {
        console.error(err);
        })
        .finally(() => {
        isFetching = false;
        });
    }

    function observeLoadMore() {
    const btnWrapper = document.querySelector(".lodeMore-btn-wpr");
    if (!btnWrapper) return;

    // Disconnect previous observer
    if (observer) {
        observer.disconnect();
    }

    observer = new IntersectionObserver(
        (entries) => {
        if (entries[0].isIntersecting && !isFetching) {
            loadMore();
        }
        },
        {
        root: null,
        threshold: 0,
        rootMargin: "0px",
        }
    );

    observer.observe(btnWrapper);
    }

    // Start observing on initial page load
    observeLoadMore();


    sorting();
    filter();
    ClearAll();
    clearLabel();
   
});
